import React from "react";

const LinksQuebrados = () => {
  return (
    <section>
    
      <iframe src="http://portal.conectt.com.br/links-quebrados/links.html" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default LinksQuebrados;
